import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState('app', ['permissions']),
    ...mapGetters({ isFeatureFlagEnabled: 'app/isFeatureFlagEnabled' }),
    dataSources() {
      // the IoT Data Hub sources stay listed so existing states keep their icon and name,
      // but without an n1 behind niotix they are flagged: the picker no longer offers them
      // for new states and the table/edit dialog show the hint
      const iotHubAvailability = this.isFeatureFlagEnabled('env_n1_enabled')
        ? {}
        : {
            unavailable: true,
            unavailableHint: this.$i18n_t('DigitalTwin.DigitalTwin.states.iotDataHubSwitchedOff'),
          };

      return [
        {
          type: 'iothub',
          name: this.$i18n_t('Common.drawer.iotDataHub'),
          image: './img/themes/n20/icon.png',
          ...iotHubAvailability,
        },
        {
          type: 'iothub-aggregate',
          name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.iothub-aggregate'),
          image: './img/themes/n20/icon.png',
          ...iotHubAvailability,
        },
      ]
        .concat([
          this.permissions['VirtualDevice.list'] ||
          this.permissions['VirtualDevice.read'] ||
          this.permissions['VirtualDevice.manage']
            ? { type: 'virtual-device', name: this.$i18n_t('DigitalTwin.VirtualDevice.title'), icon: 'sensor-on' }
            : {},
        ])
        .concat([
          this.permissions['VirtualDevice.list'] ||
          this.permissions['VirtualDevice.read'] ||
          this.permissions['VirtualDevice.manage']
            ? {
                type: 'virtual-device-aggregate',
                name: this.$i18n_t('DigitalTwin.VirtualDevice.aggregation'),
                icon: 'sensor-on',
              }
            : {},
        ])
        .concat([
          {
            type: 'bridge',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.bridge'),
            icon: 'plug',
          },
          {
            type: 'aggregate',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.aggregate'),
            icon: 'layer-group',
          },
          {
            type: 'timeseries-aggregate',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.timeseries-aggregate'),
            icon: 'history',
          },
          {
            type: 'none',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.none'),
            icon: 'save',
          },
          {
            type: 'random',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.random'),
            icon: 'dice',
          },
          {
            type: 'dynamical-data-routing',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.datarouting'),
            icon: 'route',
          },
        ])
        .filter((s) => s.type)
        .map((s) => {
          return { ...s, name: (this.sourcesNameMapping || {})[s.type] || s['name'] };
        });
    },
  },
};
